import { featureFlags } from "./flags";

export function isTrainingTabEnabled() {
  if (!featureFlags.enableTrainingTab) {
    return false;
  }

  const trainingAllowedHosts = new Set([
    "localhost",
    "dev.happyconsig.com.br",
    "staging.happyconsig.com.br",
    "portal.happyconsig.com.br",
  ]);

  const host = globalThis.location.hostname;

  return trainingAllowedHosts.has(host);
}
